Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALink = void 0;

var self_1 = require("./self");

var a_link_reset_1 = require("./a-link-reset");

exports.ALink = function (props) {
  var extraAttrs = {
    download: props.download,
    href: props.href,
    onClick: props.onClick,
    rel: props.rel,
    role: props.role,
    target: props.target
  };
  return self_1.getSelf(props, a_link_reset_1.aLinkReset, 'a', extraAttrs);
};